import { fundingRequestSchema } from './fundingRequestSchema';
import { fundingRequestTotalsSchema } from './fundingRequestTotalsSchema';

export const upsertFundingRequestResultSchema = fundingRequestSchema.extend({
  application: fundingRequestTotalsSchema,
});
